// Import all PDFs
// Mild - Collagen Powder
import mildCollagenPowder1 from './mild/collagen-powder/Sample 1500 Form-Collagen Powder-3 week pack-Below 16n2 or 103cm2.pdf';
import mildCollagenPowder2 from './mild/collagen-powder/Sample 1500 Form-Collagen Powder-3 week pack-between 16in2-48in2 or 103cm2-310cm2.pdf';
import mildCollagenPowder3 from './mild/collagen-powder/Sample 1500 Form-Collagen Powder-3 week pack-greater than 48 in2 or 310 cm2.pdf';
import mildCollagenPowder4 from './mild/collagen-powder/Sample 1500 Form-Collagen Powder-Daily Pack-  greater than 48 in2 or 310 cm2.pdf';
import mildCollagenPowder5 from './mild/collagen-powder/Sample 1500 Form-Collagen Powder-Daily Pack-Below 16n2 or 103cm2.pdf';
import mildCollagenPowder6 from './mild/collagen-powder/Sample 1500 Form-Collagen Powder-Daily Pack-between 16in2-48in2 or 103cm2-310cm2.pdf';

// Mild - Collagen Sheet
import mildCollagenSheet1 from './mild/collagen-sheet/Sample 1500 Form-Collagen Sheet-3 week pack-  greater than 48 in2 or 310 cm2.pdf';
import mildCollagenSheet2 from './mild/collagen-sheet/Sample 1500 Form-Collagen Sheet-3 week pack- Below 4in2 or 26cm2.pdf';
import mildCollagenSheet3 from './mild/collagen-sheet/Sample 1500 Form-Collagen Sheet-3 week pack- between 16in2-48in2 or 103cm2-310cm2.pdf';
import mildCollagenSheet4 from './mild/collagen-sheet/Sample 1500 Form-Collagen Sheet-Daily Pack-  Below 4in2 or 26cm2.pdf';
import mildCollagenSheet5 from './mild/collagen-sheet/Sample 1500 Form-Collagen Sheet-Daily Pack-  between 16in2-48in2 or 103cm2-310cm2.pdf';
import mildCollagenSheet6 from './mild/collagen-sheet/Sample 1500 Form-Collagen Sheet-Daily Pack-  greater than 48 in2 or 310 cm2.pdf';

// Moderate - Collagen Powder
import moderateCollagenPowder1 from './moderate/collagen-powder/Sample 1500 Form-Collagen Powder-3 week Pack- greater than 48 in2 or 310 cm2.pdf';
import moderateCollagenPowder2 from './moderate/collagen-powder/Sample 1500 Form-Collagen Powder-3 week Pack-Below 16n2 or 103cm2.pdf';
import moderateCollagenPowder3 from './moderate/collagen-powder/Sample 1500 Form-Collagen Powder-3 week Pack-between 16in2-48in2 or 103cm2-310cm2.pdf';
import moderateCollagenPowder4 from './moderate/collagen-powder/Sample 1500 Form-Collagen Powder-Daily Pack- between 16in2- 48in2 or 103cm2- 310cm2.pdf';
import moderateCollagenPowder5 from './moderate/collagen-powder/Sample 1500 Form-Collagen Powder-Daily Pack- greater than 48 in2 or 310 cm2.pdf';
import moderateCollagenPowder6 from './moderate/collagen-powder/Sample 1500 Form-Collagen Powder-Daily Pack-Below 16n2 or 103cm2.pdf';

// Moderate - Collagen Sheet
import moderateCollagenSheet1 from './moderate/collagen-sheet/Sample 1500 Form-Collagen Sheet-3 Week Pack- between 16in2-48in2 or 103cm2-310cm2.pdf';
import moderateCollagenSheet2 from './moderate/collagen-sheet/Sample 1500 Form-Collagen Sheet-3 Week Pack- greater than 48 in2 or 310 cm2.pdf';
import moderateCollagenSheet3 from './moderate/collagen-sheet/Sample 1500 Form-Collagen Sheet-3 Week Sheet- Below 4in2 or 26cm2.pdf';
import moderateCollagenSheet4 from './moderate/collagen-sheet/Sample 1500 Form-Collagen Sheet-Daily Pack- 16 in2-48in2 or 103c m2-310cm2.pdf';
import moderateCollagenSheet5 from './moderate/collagen-sheet/Sample 1500 Form-Collagen Sheet-Daily Pack- Below 4in2 or 26cm2.pdf';
import moderateCollagenSheet6 from './moderate/collagen-sheet/Sample 1500 Form-Collagen Sheet-Daily Pack- greater than 48in2 or 310cm2.pdf';

// ─── Fast Order PDF lookup ─────────────────────────────────────────────────────

export const pdfDocuments = {
  mild: {
    collagen_powder_1g: [
      { name: 'Document 1', url: mildCollagenPowder1 },
      { name: 'Document 2', url: mildCollagenPowder2 },
      { name: 'Document 3', url: mildCollagenPowder3 },
      { name: 'Document 4', url: mildCollagenPowder4 },
      { name: 'Document 5', url: mildCollagenPowder5 },
      { name: 'Document 6', url: mildCollagenPowder6 },
    ],
    collagen_sheet: [
      { name: 'Document 1', url: mildCollagenSheet1 },
      { name: 'Document 2', url: mildCollagenSheet2 },
      { name: 'Document 3', url: mildCollagenSheet3 },
      { name: 'Document 4', url: mildCollagenSheet4 },
      { name: 'Document 5', url: mildCollagenSheet5 },
      { name: 'Document 6', url: mildCollagenSheet6 },
    ],
  },
  moderate: {
    collagen_powder_1g: [
      { name: 'Document 1', url: moderateCollagenPowder1 },
      { name: 'Document 2', url: moderateCollagenPowder2 },
      { name: 'Document 3', url: moderateCollagenPowder3 },
      { name: 'Document 4', url: moderateCollagenPowder4 },
      { name: 'Document 5', url: moderateCollagenPowder5 },
      { name: 'Document 6', url: moderateCollagenPowder6 },
    ],
    collagen_sheet: [
      { name: 'Document 1', url: moderateCollagenSheet1 },
      { name: 'Document 2', url: moderateCollagenSheet2 },
      { name: 'Document 3', url: moderateCollagenSheet3 },
      { name: 'Document 4', url: moderateCollagenSheet4 },
      { name: 'Document 5', url: moderateCollagenSheet5 },
      { name: 'Document 6', url: moderateCollagenSheet6 },
    ],
  },
};

// ─── Reimbursement Guide data ──────────────────────────────────────────────────
// All 24 sample 1500 forms, grouped into one "1500" folder.
// Documents are ordered: Mild → Moderate, Collagen Powder → Collagen Sheet,
// then within each group: 3-week pack (small → large), Daily pack (small → large).

export const reimbursementGuideData = [
  {
    id: '1500',
    name: '1500',
    description: 'Sample CMS-1500 Claim Forms',
    documents: [
      // ── Mild · Collagen Powder ─────────────────────────────────────────────
      {
        name: 'Mild · Collagen Powder · 3-Week Pack · Below 16in² (103cm²)',
        url: mildCollagenPowder1,
      },
      {
        name: 'Mild · Collagen Powder · 3-Week Pack · 16–48in² (103–310cm²)',
        url: mildCollagenPowder2,
      },
      {
        name: 'Mild · Collagen Powder · 3-Week Pack · Greater than 48in² (310cm²)',
        url: mildCollagenPowder3,
      },
      {
        name: 'Mild · Collagen Powder · Daily Pack · Below 16in² (103cm²)',
        url: mildCollagenPowder5,
      },
      {
        name: 'Mild · Collagen Powder · Daily Pack · 16–48in² (103–310cm²)',
        url: mildCollagenPowder6,
      },
      {
        name: 'Mild · Collagen Powder · Daily Pack · Greater than 48in² (310cm²)',
        url: mildCollagenPowder4,
      },

      // ── Mild · Collagen Sheet ──────────────────────────────────────────────
      {
        name: 'Mild · Collagen Sheet · 3-Week Pack · Below 4in² (26cm²)',
        url: mildCollagenSheet2,
      },
      {
        name: 'Mild · Collagen Sheet · 3-Week Pack · 16–48in² (103–310cm²)',
        url: mildCollagenSheet3,
      },
      {
        name: 'Mild · Collagen Sheet · 3-Week Pack · Greater than 48in² (310cm²)',
        url: mildCollagenSheet1,
      },
      {
        name: 'Mild · Collagen Sheet · Daily Pack · Below 4in² (26cm²)',
        url: mildCollagenSheet4,
      },
      {
        name: 'Mild · Collagen Sheet · Daily Pack · 16–48in² (103–310cm²)',
        url: mildCollagenSheet5,
      },
      {
        name: 'Mild · Collagen Sheet · Daily Pack · Greater than 48in² (310cm²)',
        url: mildCollagenSheet6,
      },

      // ── Moderate · Collagen Powder ─────────────────────────────────────────
      {
        name: 'Moderate · Collagen Powder · 3-Week Pack · Below 16in² (103cm²)',
        url: moderateCollagenPowder2,
      },
      {
        name: 'Moderate · Collagen Powder · 3-Week Pack · 16–48in² (103–310cm²)',
        url: moderateCollagenPowder3,
      },
      {
        name: 'Moderate · Collagen Powder · 3-Week Pack · Greater than 48in² (310cm²)',
        url: moderateCollagenPowder1,
      },
      {
        name: 'Moderate · Collagen Powder · Daily Pack · Below 16in² (103cm²)',
        url: moderateCollagenPowder6,
      },
      {
        name: 'Moderate · Collagen Powder · Daily Pack · 16–48in² (103–310cm²)',
        url: moderateCollagenPowder4,
      },
      {
        name: 'Moderate · Collagen Powder · Daily Pack · Greater than 48in² (310cm²)',
        url: moderateCollagenPowder5,
      },

      // ── Moderate · Collagen Sheet ──────────────────────────────────────────
      {
        name: 'Moderate · Collagen Sheet · 3-Week Pack · Below 4in² (26cm²)',
        url: moderateCollagenSheet3,
      },
      {
        name: 'Moderate · Collagen Sheet · 3-Week Pack · 16–48in² (103–310cm²)',
        url: moderateCollagenSheet1,
      },
      {
        name: 'Moderate · Collagen Sheet · 3-Week Pack · Greater than 48in² (310cm²)',
        url: moderateCollagenSheet2,
      },
      {
        name: 'Moderate · Collagen Sheet · Daily Pack · Below 4in² (26cm²)',
        url: moderateCollagenSheet5,
      },
      {
        name: 'Moderate · Collagen Sheet · Daily Pack · 16–48in² (103–310cm²)',
        url: moderateCollagenSheet4,
      },
      {
        name: 'Moderate · Collagen Sheet · Daily Pack · Greater than 48in² (310cm²)',
        url: moderateCollagenSheet6,
      },
    ],
  },
];